import { ModalComponent } from '@vivli/shared/components';
import { useModalApiContext, useModalStateContext } from '@vivli/core/infrastructure/context';

export const ModalContextWrapper = () => {
    const modals = useModalStateContext();
    const { dismiss } = useModalApiContext();

    return (
        <>
            {modals
                ?.filter((m) => m.visible)
                .map((modal) => (
                    <ModalComponent onDismiss={dismiss} modal={modal} key={modal.id} />
                ))}
        </>
    );
};
